import React from 'react';
import SapFinanceContent from '../function-components/SAPFinanace/SapFinanceContent';

const SapFinance = () => {
  return (
    <SapFinanceContent />
  )
}

export default SapFinance